import React from "react";
import useIndexerIndicesMultiple from "components/indexers/hooks/useIndexerIndicesMultiple";
import { Spinner } from "components/common";
import IndicesOverview from "components/indices/IndicesOverview";
const ArchiveIndicesOverview = ({ indices, indexSetOverview }) => {
  const { data: indicesDetails, isLoading: isLoadingIndicesDetails } = useIndexerIndicesMultiple(indices);
  if (isLoadingIndicesDetails) return /* @__PURE__ */ React.createElement(Spinner, null);
  if (!indicesDetails || indicesDetails.length < 1 || !indexSetOverview) return null;
  return /* @__PURE__ */ React.createElement(IndicesOverview, { indexDetails: indicesDetails, indices: indexSetOverview.indices });
};
export default ArchiveIndicesOverview;
